export default "__VITE_ASSET__BkYqcXC2__"